/**
 * physics.js
 * 3. VA CHẠM, MẤT THĂNG BẰNG & NGÃ VẬT LÝ
 */

export const PHYSICS_POSES = {
  stumble: (pose, time) => {
    // Loạng choạng (Loop: Chân so le chéo, thân chao đảo mất thăng bằng)
    const stCycle = time * 5.5;
    pose.torsoRotZ = Math.sin(stCycle * 0.8) * 0.28; // Lắc ngang thân
    pose.torsoRotX = 0.22 + Math.sin(stCycle) * 0.15; // Nhấp nhô trước sau
    pose.pelvisRotZ = Math.sin(stCycle * 0.8) * 0.15;
    // Chân bước lảo đảo khụy gối
    pose.leftLegRotX = Math.sin(stCycle) * 0.42;
    pose.rightLegRotX = -Math.sin(stCycle) * 0.42;
    pose.leftCalfRotX = Math.abs(Math.sin(stCycle)) * 0.45;
    pose.rightCalfRotX = Math.abs(Math.cos(stCycle)) * 0.45;
    pose.leftLegRotZ = -Math.sin(stCycle * 0.8) * 0.2;
    pose.rightLegRotZ = Math.sin(stCycle * 0.8) * 0.2;
    // Hai tay quờ quạng tìm điểm bám
    pose.leftArmRotX = -0.75 + Math.sin(stCycle * 1.2) * 0.45;
    pose.rightArmRotX = -0.75 - Math.cos(stCycle * 1.2) * 0.45;
    pose.leftForearmRotX = -0.65;
    pose.rightForearmRotX = -0.65;
    pose.leftArmRotZ = -0.45 + Math.sin(stCycle) * 0.25;
    pose.rightArmRotZ = 0.45 + Math.cos(stCycle) * 0.25;
    pose.headRotZ = -pose.torsoRotZ * 0.8;
  },

  fall_backward: (pose, time, elapsed, anim) => {
    // Bị ngã ngửa ra đằng sau (One-shot: Trượt chân -> Ngã bẹp xuống sàn -> Nằm bất động)
    const t = Math.min(elapsed, 1.5);
    const groundDrop = -(anim.basePelvisY - 0.12); // Hạ pelvis sát sàn

    if (t < 0.25) {
      // Mất thăng bằng ngửa ra
      const p = t / 0.25;
      pose.torsoRotX = -p * 0.35;
      pose.rootY = -p * 0.08;
      pose.leftLegRotX = -p * 0.35;
      pose.rightLegRotX = -p * 0.3;
      pose.leftCalfRotX = p * 0.45;
      pose.rightCalfRotX = p * 0.45;
      pose.leftArmRotX = -p * 0.8;
      pose.rightArmRotX = -p * 0.8;
      pose.leftForearmRotX = -p * 0.4;
      pose.rightForearmRotX = -p * 0.4;
    } else if (t < 0.75) {
      // Đập lưng xuống sàn
      const p = (t - 0.25) / 0.5;
      pose.pelvisRotX = -p * (Math.PI / 2);
      pose.rootY = -0.08 + p * (groundDrop + 0.08);
      pose.leftLegRotX = -0.35 * (1 - p);
      pose.rightLegRotX = -0.3 * (1 - p);
      pose.leftCalfRotX = 0.45 * (1 - p);
      pose.rightCalfRotX = 0.45 * (1 - p);
      pose.leftArmRotX = -0.8 - p * 0.7;
      pose.rightArmRotX = -0.8 - p * 0.7;
      pose.leftForearmRotX = -0.4 * (1 - p);
      pose.rightForearmRotX = -0.4 * (1 - p);
    } else {
      // Nằm bẹp dưới đất, đầu ngọ nguậy thở dốc
      pose.pelvisRotX = -Math.PI / 2;
      pose.rootY = groundDrop;
      pose.headRotX = 0.15 + Math.sin(time * 3.0) * 0.04;
      pose.leftArmRotX = -1.55;
      pose.rightArmRotX = -1.55;
      pose.leftForearmRotX = -0.2;
      pose.rightForearmRotX = -0.2;
      pose.leftArmRotZ = -0.55;
      pose.rightArmRotZ = 0.55;
    }
  },

  fall_forward: (pose, time, elapsed, anim) => {
    // Ngã sập về phía trước (One-shot: Vấp chân chúi tới trước -> Đập sấp sàn)
    const t = Math.min(elapsed, 1.5);
    const groundDrop = -(anim.basePelvisY - 0.12);

    if (t < 0.25) {
      // Chúi đầu về trước
      const p = t / 0.25;
      pose.torsoRotX = p * 0.4;
      pose.leftArmRotX = -p * 1.2;
      pose.rightArmRotX = -p * 1.2;
      pose.leftForearmRotX = -p * 0.6;
      pose.rightForearmRotX = -p * 0.6;
    } else if (t < 0.75) {
      // Bổ nhào sấp xuống sàn
      const p = (t - 0.25) / 0.5;
      pose.pelvisRotX = p * (Math.PI / 2);
      pose.rootY = p * groundDrop;
      pose.leftArmRotX = -1.2 - p * 1.4;
      pose.rightArmRotX = -1.2 - p * 1.4;
      pose.leftForearmRotX = -0.6 - p * 0.6;
      pose.rightForearmRotX = -0.6 - p * 0.6;
    } else {
      // Nằm sấp mặt trên sàn, tay đỡ đầu
      pose.pelvisRotX = Math.PI / 2;
      pose.rootY = groundDrop;
      pose.headRotX = -0.22 + Math.sin(time * 2.5) * 0.03;
      pose.leftArmRotX = -2.7;
      pose.rightArmRotX = -2.7;
      pose.leftForearmRotX = -1.2; // Khuỷu gập ôm đầu
      pose.rightForearmRotX = -1.2;
      pose.leftArmRotZ = -0.32;
      pose.rightArmRotZ = 0.32;
    }
  },

  roll_ground: (pose, time, _elapsed, anim) => {
    // Lăn tròn dưới đất (Loop: Thân nằm sát sàn và lăn 360 độ, tay chân co gọn)
    const groundDrop = -(anim.basePelvisY - 0.14);
    pose.rootY = groundDrop;
    pose.pelvisRotX = -Math.PI / 2; // Nằm ngang trên sàn
    pose.pelvisRotY = time * 3.8; // Lăn tròn quanh trục thân
    // Tay co lại ôm người
    pose.leftArmRotX = -1.6;
    pose.rightArmRotX = -1.6;
    pose.leftForearmRotX = -1.45; // Gập cùi chỏ ôm sát ngực
    pose.rightForearmRotX = -1.45;
    pose.leftArmRotZ = 0.2;
    pose.rightArmRotZ = -0.2;
    pose.leftLegRotX = -0.25;
    pose.rightLegRotX = -0.25;
    pose.leftCalfRotX = 0.85; // Gối co gọn khi lăn
    pose.rightCalfRotX = 0.85;
  }
};
